import { Injectable } from "@angular/core";
import { CookieService } from "@obg/ngx.global.evo";

import { GeofencingConfigService } from "./geofencing.config";

@Injectable({ providedIn: "root" })
export class GeofencingExperimentService {
	constructor(
		private cookieService: CookieService,
		private config: GeofencingConfigService
	) {}

	isGeofencingDisabled(): boolean {
		const experiments = this.cookieService.get("obg-experiments");
		return !!experiments?.includes(this.config.getDisableExperimentKey());
	}

	isGeofencingIpLocationCheckDisabled(): boolean {
		const experiments = this.cookieService.get("obg-experiments");
		return !!experiments?.toLowerCase().includes("iplocationcheckdisabled");
	}
}
